import "./Coins.css";

interface Props {
  count: number;
  /** "+22" style, for a round's earnings. */
  delta?: boolean | undefined;
  className?: string | undefined;
}

/** A coin and a number. */
export function Coins({ count, delta = false, className }: Props) {
  const n = Math.max(0, Math.round(count));
  return (
    <span
      className={["coins", className].filter(Boolean).join(" ")}
      role="img"
      aria-label={`${delta ? "plus " : ""}${n} coin${n === 1 ? "" : "s"}`}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" className="coin">
        <circle cx="12" cy="12" r="11" fill="#f5b82e" stroke="#b3830f" strokeWidth="2" />
        <circle cx="12" cy="12" r="7" fill="none" stroke="#b3830f" strokeWidth="1.5" />
        <path
          d="M12 7.5v9M9.5 9.5h4a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 0 0 3h4"
          fill="none"
          stroke="#b3830f"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
      <b className="display">
        {delta ? "+" : ""}
        {n}
      </b>
    </span>
  );
}
